import { PADMode } from '@mts/utils/env';

export const tableCellCompOptions = [
  // { value: 'RenderColor', label: '颜色块' },
  { value: 'RenderBadge', label: '状态点', useMapValue: true },
  { value: 'RenderTag', label: '标签', useMapValue: true },
  { value: 'RenderTextTag', label: '文本标签', useMapValue: true },
  { value: 'RenderDict', label: '字典映射', useMapValue: true },
  { value: 'RenderLink', label: '超链接' },
  { value: 'RenderImage', label: '图片预览' },
  { value: 'RenderProgress', label: '进度条' },
  { value: 'RenderPopover', label: '更多字段集' },
  { value: 'RenderParagraph', label: '长文本（已废弃）', disabled: true },
  { value: 'RenderText', label: '文本（已废弃）', disabled: true },
];

/** 需要获取映射数据的组件 */
export const useMapValueComps = tableCellCompOptions
  .filter((i) => i.useMapValue)
  .map((i) => i.value);

export const fieldCompOptions = [
  { value: 'Input', label: '输入框' },
  { value: 'InputNumber', label: '数值输入框' },
  { value: 'ApiSelect', label: '单选下拉框' },
  { value: 'ApiMultipleSelect', label: '多选下拉框' },
  { value: 'ApiSelectSearch', label: '输入查询下拉框' },
  { value: 'ApiInputAddSelect', label: '输入新增下拉框' },
  { value: 'ModalTableSelect', label: '弹窗选择框' },
  { value: 'ApiSelectAdd', label: '下拉新增' },
  { value: 'ApiTreeSelect', label: '树形选择（部门）' },
  // { value: 'ApiCascader', label: '级联选择' },
  // { value: 'ColorPicker', label: '颜色选择面板' },
  { value: 'ApiRadioGroup', label: '单选框' },
  { value: 'ApiRadioButtonGroup', label: '单选按钮组' },
  { value: 'ApiSegmentedSearch', label: '查询分段按钮' },
  { value: 'ApiSegmented', label: '分段按钮' },
  { value: 'Switch', label: '开关' },
  { value: 'Textarea', label: '多行文本框' },
  { value: 'MUpload', label: '文件上传' },
  { value: 'TimePicker', label: '时间选择框（HH:mm）' },
  { value: 'DatePicker', label: '日期选择框（YYYY/MM/DD）' },
  { value: 'DateTimePicker', label: '日期时间选择框（YYYY/MM/DD HH:mm）' },
  { value: 'MonthPicker', label: '月份选择框（YYYY/MM）' },
  { value: 'YearPicker', label: '年份选择框（YYYY）' },
  { value: 'DateInput', label: '日期手动输入框（YYYY/MM/DD）' },
  { value: 'TimeInput', label: '时间手动输入框（HH:mm）' },
  { value: 'RangePicker', label: '日期区间选择框' },
  { value: 'QuickRangePicker', label: '日期区间选择框（快捷）' },
  { value: 'RangeTimePicker', label: '日期时间区间选择框' },
  { value: 'InputCode', label: '输入编号' },
  { value: 'InputRange', label: '输入区间' },
  // { value: 'VirtualInput', label: '虚拟数字键盘' },
  { value: 'TooltipText', label: '提示+溢出省略' },
  { value: 'ReadonlyNumber', label: '数值（千分位）' },
  { value: 'ReadonlyText', label: '只读文本' },
];

export const renderCompMap = {
  ApiSelectSearch: 'ApiSelect',
  ApiMultipleSelect: 'ApiSelect',
  ApiInputAddSelect: 'ApiSelect',
  ApiRadioButtonGroup: 'ApiRadioGroup',
  ApiSegmentedSearch: 'ApiSegmented',
  InputNumber: PADMode ? 'Stepper' : 'InputNumber',
  DateTimePicker: 'DatePicker',
  MonthPicker: 'DatePicker',
  YearPicker: 'DatePicker',
  RangeTimePicker: 'RangePicker',
  DateInput: 'Input',
  TimeInput: 'Input',
};
